<template>
  <div class="survey">
    <modal v-if="!seenInstruction && instructions" @submit="seenInstruction=true" @close="seenInstruction=true" btn="close" title="Instructions">
      {{instructions}}
    </modal>
    <div v-infinite-scroll="findNext" infinite-scroll-disabled="busy" infinite-scroll-distance="600">
      <div v-for="(question, $index) in currentQuestions" :key="question.id" :id="'question-' + $index">
        <question :question="question" :number="$index + 1" @next="next" :active="current == $index"  class="big-top"/>
      </div>
    </div>
    <survey-progress :currentQuestion="current" :totalQuestions="questions.length" />
  </div>  
</template>

<script>
import question from "./question";
import progress from "./progress";
import scrollIntoView from "scroll-into-view";
import modal from "@/components/modal/default";

export default {
  props: ["questions", "instructions"],
  components: { question, surveyProgress: progress, modal },
  data() {
    return {
      current: 0,
      currentQuestions: [],
      busy: false,
      seenInstruction: false
    };
  },
  created() {
    this.currentQuestions = this.questions.slice(0, 50);
  },
  methods: {
    next() {
      this.current = this.currentQuestions.findIndex(q => q.answer === undefined);

      if (this.current === -1) {
        if (this.questions.length == this.currentQuestions.length) {
          this.current = this.questions.length;
          this.$emit("finished");
          return;
        } else {
          this.findNext();
          this.next();
        }
      }
      var element = document.getElementById("question-" + this.current);
      scrollIntoView(element);
    },
    findNext() {
      let offset = this.currentQuestions.length;
      if (this.offset === this.questions.length) {
        this.busy = true;
        return;
      }
      this.currentQuestions = [...this.currentQuestions, ...this.questions.slice(offset, offset + 15)];
    }
  },
};
</script>

<style lang="less" scoped>
.survey {
  max-width: 600px;
  margin: 0px auto;
  .big-top {
    margin-top: 20px;
  }
};

</style>
